module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', [_c('Select', {
    attrs: {
      "label": "Муниципалитет",
      "type": "text",
      "placeholder": "Выберите муниципалитет",
      "required": true,
      "v": _vm.v.municipality_id,
      "error-text": _vm.errors.municipality_id || 'Обязательное поле',
      "error": _vm.errors.municipality_id,
      "options": _vm.municipalitiesOptions
    },
    model: {
      value: (_vm.invitePerson.municipality_id),
      callback: function($$v) {
        _vm.$set(_vm.invitePerson, "municipality_id", $$v)
      },
      expression: "invitePerson.municipality_id"
    }
  }), _c('FormInput', {
    attrs: {
      "label": "Имя",
      "type": "text",
      "placeholder": "Введите имя",
      "required": true,
      "v": _vm.v.first_name,
      "error-text": _vm.firstNameErrorText || _vm.errors.first_name || 'Обязательное поле',
      "error": _vm.errors.first_name
    },
    on: {
      "input": function($event) {
        return _vm.onInput('invitePerson.first_name')
      }
    },
    model: {
      value: (_vm.invitePerson.first_name),
      callback: function($$v) {
        _vm.$set(_vm.invitePerson, "first_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "invitePerson.first_name"
    }
  }), _c('FormInput', {
    attrs: {
      "label": "Фамилия",
      "type": "text",
      "placeholder": "Введите фамилию",
      "required": true,
      "v": _vm.v.last_name,
      "error-text": _vm.lastNameErrorText || _vm.errors.last_name || 'Обязательное поле',
      "error": _vm.errors.last_name
    },
    on: {
      "input": function($event) {
        return _vm.onInput('invitePerson.last_name')
      }
    },
    model: {
      value: (_vm.invitePerson.last_name),
      callback: function($$v) {
        _vm.$set(_vm.invitePerson, "last_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "invitePerson.last_name"
    }
  }), _c('FormInput', {
    attrs: {
      "label": "Электронная почта",
      "type": "text",
      "placeholder": "Введите email",
      "required": true,
      "v": _vm.v.email,
      "error-text": _vm.emailErrorText,
      "error": _vm.errors.email
    },
    model: {
      value: (_vm.invitePerson.email),
      callback: function($$v) {
        _vm.$set(_vm.invitePerson, "email", $$v)
      },
      expression: "invitePerson.email"
    }
  }), _c('FormInput', {
    attrs: {
      "placeholder": "Введите номер телефона",
      "label": "Телефон",
      "error-text": "Пожалуйста, введите корректный номер телефона.",
      "required": true,
      "v": _vm.v.phone,
      "mask": _vm.phoneMask
    },
    model: {
      value: (_vm.invitePerson.phone),
      callback: function($$v) {
        _vm.$set(_vm.invitePerson, "phone", $$v)
      },
      expression: "invitePerson.phone"
    }
  }), _c('FormInput', {
    attrs: {
      "placeholder": "Введите СНИЛС",
      "label": "СНИЛС",
      "error": !!_vm.errors.snils,
      "error-text": _vm.errors.snils || _vm.snilsErrorText,
      "required": true,
      "v": _vm.v.snils,
      "mask": _vm.snilsMask
    },
    model: {
      value: (_vm.invitePerson.snils),
      callback: function($$v) {
        _vm.$set(_vm.invitePerson, "snils", $$v)
      },
      expression: "invitePerson.snils"
    }
  }), _c('Button', {
    attrs: {
      "disabled": !_vm.validateForm
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.submitBtnText))]), _c('Button', {
    attrs: {
      "bordered": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Назад")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03193ef8","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/addchildform/AddChild.vue
// module id = 572f0be9858dfc5dc168
// module chunks = 89